export default __webpack_public_path__ + "static/media/Thumb_Accessories_05.f59411e6.png";